{
    "formRows": [
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "msme",
              "displayLabel": "MSME",
              "skipLabel": true,
              "defaultValue": false,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "udyamNo",
              "displayLabel": "Udyam No",
              "placeHolder": "Enter Udyam No",
              "fieldInfo": {
                "dataType": "text"
              },
              "conditions": {
                  "visibility": {
                    "rules": [
                      { "field": "msme", "operator": "EQUALS", "value": true }
                    ]
                  }
                },
              "validators": [
                {
                  "type": "required",
                  "message": "Udyam No is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "msmeType",
              "displayLabel": "MSME Type",
              "placeHolder": "Select MSME Type",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                    {
                        "value": "MIRCO",
                        "label": "Micro"
                    },
                    {
                        "value": "SMALL",
                        "label": "Small"
                    },
                    {
                        "value": "MEDIUM",
                        "label": "Medium"
                    }
                ]
              },
              "conditions": {
                "visibility": {
                  "rules": [
                    { "field": "msme", "operator": "EQUALS", "value": true }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "MSME Type is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
                "label": "msmeValidityDate",
                "displayLabel": "MSME Validity Date",
                "placeHolder": "Select MSME Validity Date",
                "fieldInfo": {
                    "dataType": "date"
                },
                "conditions": {
                  "visibility": {
                    "rules": [
                        { "field": "msme", "operator": "EQUALS", "value": true }
                    ]
                  }
                },
                "validators": [
                    {
                    "type": "required",
                    "message": "MSME Validity Date is required"
                    }
                ]
            }
          }
        ]
      }
    ]
}